import Heading from '../../../../LuxKit/Typography/Heading'
import useToggle from 'hooks/useToggle'
import TextLink from '../../../../LuxKit/TextLink'
import LayoutContainer from '../../Common/LayoutContainer'
import FaqStructuredData from './FaqStructuredData'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import MarkdownRender from 'LuxKit/MarkdownRender'
import Accordion from 'LuxKit/Accordion'
import { take } from 'lib/array/arrayUtils'
import Expander from 'components/utils/Expander'
import { useIntl } from 'react-intl'

interface Props {
  heading: string
  items: Array<App.QuestionAndAnswer>
  maxToShow?: number
  size?: 'sm' | 'lg'
}

function FrequentlyAskedQuestions({
  heading,
  items,
  maxToShow = 5,
  size = 'sm',
}: Props) {
  const intl = useIntl()
  const [isExpanded, toggleIsExpanded] = useToggle()
  const hasExtrasToExpand = items.length > maxToShow

  const showLessLabel = intl.formatMessage({
    id: 'ghyfEEuUOdzzwpIHp4Cj',
    defaultMessage: 'Show Less',
  })
  const showMoreLabel = intl.formatMessage({
    id: 'KiJxEPfBpGajq2dHDg4c',
    defaultMessage: 'Show More',
  })
  const toggleLabel = isExpanded ? showLessLabel : showMoreLabel

  return (
    <LayoutContainer size="md">
      <VerticalSpacer gap={16}>
        <FaqStructuredData items={items} />
        {heading && <Heading as="h3" variant="heading3" align="center">{heading}</Heading>}
        <div>
          {take(items, maxToShow).map((item) => (
            <Accordion
              key={item.question}
              size={size == 'sm' ? 'small' : 'large'}
              heading={item.question}
            >
              <MarkdownRender content={item.answer} />
            </Accordion>
          ))}
          {hasExtrasToExpand && <Expander expanded={isExpanded}>
            {take(items, items.length, maxToShow).map((item) => (
              <Accordion
                key={item.question}
                size={size == 'sm' ? 'small' : 'large'}
                heading={item.question}
              >
                <MarkdownRender content={item.answer} />
              </Accordion>
            ))}
          </Expander>}
        </div>
        {hasExtrasToExpand && (
          <TextLink onClick={toggleIsExpanded}>
            {toggleLabel}
          </TextLink>
        )}
      </VerticalSpacer>
    </LayoutContainer>
  )
}

export default FrequentlyAskedQuestions
